/**
 * 财务--》报表
*/

export default {
    old_branch_profit_statement_old_filter: ["73367"], // 202509151159143033173 改成旧网点利润表，老筛选条件，年月https://imagecdn.ymm56.com/ymmfile/static/resource/97c667c9-0c1e-42a3-8914-abe22d989bfb.png 新筛选条件时间选择器https://imagecdn.ymm56.com/ymmfile/static/resource/5c27b679-12fc-4815-8b30-a39e9734d308.png
    website_profit_type: ['84139'], //202509051247290736067 84139网点利润表，线路利润表，客户基本运费-其他费用-回付司机运费税金,运费税金-回扣税金-其他费用税金-回付司机运费查看详情时更换gridId
    quality_ranking_analysis_consigner: ['92556'], //202510181353196072827 货量排名分析表-发货人字段替换成发货单位
    aging_analysis_frozen_column: ['97089'], //202510171136416707551 账龄分析 客户名称冻结列
    remove_grayed_out_reports: ['87388'], //202510131857005838162 报表中心 不显示置灰的报表
    report_shipment_collect:['92556'], // 202510181547553506179 发货按月汇总报表
    // 客户账龄分析表占比
    aging_analysis_proportion: ['88114'], //202512121006201003540 账龄分析 客户账龄分析表占比
    branch_reconciliation_detail: ['88569','90100','82635'], //202507151803064909903 分公司对账明细单功能
}

